<template>
  <div v-if="renderReady" class="container-fluid form-container-fluid">
    <div class="row">
      <div class="col-4">
        <label v-if="getTitle" class="label">{{ getTitle }}</label>
      </div>
      <div class="col-8">
        <div class="input" :class="{ 'state-error': model.$error, 'state-disabled': disabled && !borderless }">
          <input
            ref="input"
            :type="type"
            class="form-control input-width float-left"
            :class="{ borderless: borderless, 'text-right': model.$schema.type == 'number' || model.$schema.type == 'money' || model.$schema.type == 'integer' }"
            :disabled="disabled"
            :readonly="model.$schema.readOnly"
            :value="svalue"
            @input="onInput($event)"
            @focus="onFocus($event)"
            @blur="onBlur($event)"
            @mouseover="mouseOver($event)"
            @mouseleave="mouseOut($event)"
          />
        </div>
        <w-error :model="model" @focus="$refs.input.focus()"></w-error>
      </div>
    </div>
  </div>
</template>

<script>
//         v-tooltip.notrigger="{content: tooltipContent, visible: !getTitle && tooltipVisibility}"

import modelMixin from '@/mixins/modelMixin';
import WError from './error.vue';

export default {
  components: { WError },
  props: {
    placeholder: String,
    type: {
      type: String,
      default: 'text'
    }
  },
  mixins: [modelMixin],
  data() {
    return {};
  },
  computed: {},
  methods: {}
};
</script>

<style>
.input-width {
  width: 90% !important;
  margin-bottom: 1em;
}
.form-container-fluid {
  margin: 1em !important;
}
</style>
